<div class="maincontainer font-sans">
  <!-- Transparent overlay layer - shown only when settings popup is open -->
  <div *ngIf="showSettings" class="fixed inset-0 bg-opacity-30 z-10" (click)="closeSettings()"></div>
  
  <div class="flex flex-col md:flex-row h-screen">
    <!-- Mobile Header with Menu Toggle -->
    <div class="block md:hidden bg-white p-4 shadow-sm">
      <div class="flex items-center justify-between">
        <img alt="Atlas Track Logo" class="h-8" src="assets/newui/atlasnewlogo.png"/>
        <button class="text-gray-600" (click)="toggleMenu()">
          <i class="fas fa-bars text-xl"></i>
        </button>
      </div>
    </div>

    <!-- Sidebar - Hidden on mobile by default, shown when toggled -->
    <div class="w-full md:w-80 bg-white p-4   sidebar-menu" [ngClass]="{'hidden': !menuOpen, 'block': menuOpen, 'md:block': true}">
      <div class="flex items-center justify-center h-12 md:h-16 mb-6">
          <img alt="Atlas Track Logo" class="max-w-full h-auto" src="assets/newui/atlasnewlogo.png" width="180"/>
      </div>
      <div class="mt-4 md:mt-10">
          <a class="flex items-center py-2 px-4 md:px-8 hover:bg-purple-50 hover:rounded-lg text-gray-900 hover:text-purple-700 cursor-pointer" (click)="onHomeClick()">
              <i class="fas fa-th-large mr-3"></i>
              <span>Home</span>
          </a>
          
          <!-- Reports Dropdown Menu -->
          <div class="relative">
              <!-- Reports Menu Header -->
              <a class="flex items-center py-2 px-4 md:px-8 text-gray-600 mt-3 hover:bg-purple-50 hover:rounded-lg hover:text-purple-700 cursor-pointer" (click)="toggleReportsDropdown()">
                  <i class="fas fa-file-alt mr-3"></i>
                  <span>Download Reports</span>
                  <i class="fas fa-caret-down ml-auto" [ngClass]="{'transform rotate-180': reportsDropdownOpen}"></i>
              </a>
              
              <!-- Dropdown Items -->
              <div class="pl-8 md:pl-12 overflow-hidden transition-all duration-300" [ngClass]="{'max-h-0': !reportsDropdownOpen, 'max-h-48': reportsDropdownOpen}">
                  <a class="flex  items-center py-3 px-1 text-sm text-gray-600 hover:text-purple-700 cursor-pointer" (click)="onBILOGReport()">
                      <i class="fas fa-file-alt mr-3"></i>
                      <span>Biological Indicator Report</span>
                  </a>
                  <a class="flex items-center py-2 px-1 text-sm text-gray-600 hover:text-purple-700 cursor-pointer" (click)="onUltrasonicReport()">
                      <i class="fas fa-file-alt mr-3"></i>
                      <span>Ultrasonic/Washer Report</span>
                  </a>
                  <a class="flex items-center py-2 px-1 text-sm text-gray-600 hover:text-purple-700 cursor-pointer" (click)="onWaterTestReport()">
                      <i class="fas fa-file-alt mr-3"></i>
                      <span>Waterline Test Report</span>
                  </a>
              </div>
          </div>
          
          <a class="flex  items-center py-2 mt-3 px-4 md:px-8 text-gray-600 hover:bg-purple-50 hover:text-purple-700 hover:rounded-lg" (click)="onDeviceDetail()">
              <i class="fas fa-database mr-3"></i>
              <span>Biological Indicator Device</span>
          </a>
      </div>
  </div>
  

    <!-- Main Content -->
    <div class="flex-1 flex flex-col">
      <!-- Header -->
      <header class="flex items-center justify-between h-16 md:h-24 px-4 md:px-6 bg-white shadow-sm md:shadow-none">
        <div class="flex items-center">
          <h1 class="text-gray-600 text-sm font-medium">
            Dashboard / WaterTesting Log
          </h1>
        </div>
        <div class="flex items-center">
          <div class="relative">
          </div>
          <div class="flex items-center gap-2 md:gap-4">
            <i class="fas fa-bell text-gray-400 mr-2 md:mr-4"></i>
          
            <div class="relative">
              <div class="flex items-center gap-2 cursor-pointer z-20" (click)="toggleSettings($event)">
                <img alt="User Avatar" class="rounded-full w-8 h-8 md:w-10 md:h-10" src="assets/newui/demoprofile.png" />
                <span class="text-gray-600 hidden sm:inline">{{username}}</span>
                <i class="fas fa-caret-down ml-auto"></i>
              </div>
              
              <!-- Setting popup with relative positioning and higher z-index -->
              <div *ngIf="showSettings" class="bg-white shadow-xl rounded-lg p-3 absolute right-0 top-full mt-2 z-20 w-48 md:w-64">
                <div class="flex gap-3 p-2 hover:bg-gray-100 rounded cursor-pointer" (click)="onManageAccount()">
                  <img src="assets/newui/icons/manageAccountIcon.png" class="w-4 h-4" alt="">
                  <p class="text-sm"> Manage Account </p>
                </div>
                <hr class="mt-2">
                <div class="flex gap-3 p-2 hover:bg-gray-100 rounded cursor-pointer" (click)="onForgetPassword()">
                  <img src="assets/newui/icons/changePasswordIcon.png" class="w-4 h-4 mt-1" alt="">
                  <p class="text-sm"> Change Password </p>
                </div>
                <!-- <hr class="mt-2">
                <div class="flex gap-3 p-2 hover:bg-gray-100 rounded cursor-pointer">
                  <img src="assets/newui/icons/activityLogIcon.png" class="w-4 h-4 mt-1" alt="">
                  <p class="text-sm"> Activity Log </p>
                </div> -->
                <hr class="mt-2">
                <div class="flex gap-3 p-2 hover:bg-gray-100 rounded cursor-pointer" (click)="onLogoutClick()">
                  <img src="assets/newui/icons/logoutIcon.png" class="w-5 h-4 mt-1" alt="">
                  <p class="text-sm"> Logout </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <!-- Main Section -->
      <main class="flex-1 p-4 md:p-6 overflow-auto">
        <p class="font-bold text-xl md:text-2xl mb-2 md:ml-4">Waterline Test Log</p>
        <div class="bg-white min-h-screen p-4">
          <div *ngIf="showForm" class="bg-white rounded-lg shadow-lg p-4 md:p-2 w-full">
            
            <div class="flex flex-col md:flex-row mb-8">
              
              <p class="text-lg font-bold py-2 mb-4 md:mb-0 md:w-1/3">
                  Add Information
              </p>
         
              <div class="flex flex-col sm:flex-row gap-2 py-1 md:ml-auto">
                <button class="printbtn text-white text-sm px-6 py-1 shadow-xl cursor-pointer hover:shadow-xl" (click)="generatePDF()">
                  Print
                  <i class="fas fa-print text-white ml-2"></i>
                </button>
                <a class="visitmorebtn text-muted bg-gray-300 px-6 text-sm py-1 shadow-lg" href="https://penguinhealth.ca/">
                 <p class="mt-3"> Visit More </p>
                </a>
              </div>
            </div>
          
            <div class="title mb-6">
              <p>Results</p>
            </div>
            
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
           
              <div>
                <label class="fieldsHeading">Sample Date</label>
                <input 
                  class="w-full p-3 md:p-3 fields mt-2" 
                  type="datetime-local"
                  [(ngModel)]="formData.date"
                />
              </div>
        
              <div>
                <label class="fieldsHeading">Team Member</label>
                <app-customcombobox 
                  [items$]="technicians$" 
                  placeholder="Type Or Select Team Member" 
                  (selectionChange)="onTeamMemberSelected($event)"
                  [hasError]="hasError('teamMember')"
                ></app-customcombobox>
                <p *ngIf="hasError('teamMember')" class="text-red-500 text-sm mt-1">
                  Please select a team member
                </p>
              </div>

              <div  *ngIf="!showCustomLocationField">
                <label class="fieldsHeading">Locations</label>
                <app-customcombobox 
                  [items$]="locations$" 
                  placeholder="Select Location" 
                  (selectionChange)="onLocationSelected($event)"
                  [hasError]="hasError('location')"
                ></app-customcombobox>
                <p *ngIf="hasError('location')" class="text-red-500 text-sm mt-1">
                  Please select a location
                </p>
              </div>

              <!-- Custom Location Field - Only shown if "Add more" is selected -->
              <div *ngIf="showCustomLocationField">
                <label class="fieldsHeading">Locations</label>
                <input 
                  class="w-full p-3 md:p-3 fields mt-2" 
                  type="text"
                  placeholder="Add New Location"
                  [(ngModel)]="formData.customLocation"
                  [ngClass]="{'border-red-500': hasError('customLocation')}"
                />
                <p *ngIf="hasError('customLocation')" class="text-red-500 text-sm mt-1">
                  Please enter a custom location
                </p>
              </div>

              <div>
                <label class="fieldsHeading">Device</label>
                <app-customcombobox 
                  [items$]="devices$" 
                  placeholder="Type Or Select Device" 
                  (selectionChange)="onDeviceSelected($event)"
                  [hasError]="hasError('device')"
                  
                ></app-customcombobox>
                <p *ngIf="hasError('device')" class="text-red-500 text-sm mt-1">
                  Please select a device
                </p>
              </div>

              <div>
                <label class="fieldsHeading">Date of Result</label>
                <input 
                  class="w-full p-3 md:p-3 fields mt-2" 
                  type="date"
                  [(ngModel)]="formData.dateOfResult"
                />
              </div>

              <div>
                <label class="fieldsHeading">Result</label>
                <app-customcombobox 
                  [items$]="passFailOptions$" 
                  placeholder="Select Result" 
                  (selectionChange)="onTestResultSelected($event)"
                  [hasError]="hasError('testResult')"
                ></app-customcombobox>
                <p *ngIf="hasError('testResult')" class="text-red-500 text-sm mt-1">
                  Please select test result
                </p>
              </div>
            </div>
      
            <div class="">
              <label class="fieldsHeading">Safety Level</label>
              <div class="gap-2 flex mt-3 mb-3">
                <input 
                  type="radio" 
                  name="safetyLevel" 
                  value="safe" 
                  class="w-8 h-8 safety-radio border-2 border-green-500" 
                  (change)="updateSafetyColor($event)" 
                  id="safetyRadio1"
                  [ngClass]="{'border-red-500': hasError('safetyLevel')}"
                />
                <input 
                  type="radio" 
                  name="safetyLevel" 
                  value="warning" 
                  class="w-8 h-8 safety-radio border-2 border-yellow-500" 
                  (change)="updateSafetyColor($event)" 
                  id="safetyRadio2"
                  [ngClass]="{'border-red-500': hasError('safetyLevel')}"
                />
                <input 
                  type="radio" 
                  name="safetyLevel" 
                  value="danger" 
                  class="w-8 h-8 safety-radio border-2 border-red-600" 
                  (change)="updateSafetyColor($event)" 
                  id="safetyRadio3"
                  [ngClass]="{'border-red-500': hasError('safetyLevel')}"
                />
              </div>
              <p *ngIf="hasError('safetyLevel')" class="text-red-500 text-sm mt-1">
                Please select a safety level
              </p>
            </div>

            <div>
              <label class="fieldsHeading">Corrective Action (Optional)</label>
              <br>
              <textarea 
                class="bg-gray-200 mt-2 w-full h-40 p-3"
                [(ngModel)]="formData.correctiveAction"
              ></textarea>
            </div>

            <div class="flex flex-col sm:flex-row gap-4 mt-10 mb-6">
              <button 
                class="savebtn text-white px-8 py-2"
                [disabled]="isSubmitting"
                (click)="onSaveClick()">
                {{ isSubmitting ? 'Saving...' : 'Save' }}
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>

  <app-notification-popup 
    [isOpen]="showPopup" 
    [message]="popupMessage" 
    [type]="popupType" 
    (onClose)="closePopup()"
  ></app-notification-popup>
</div>